export default "__VITE_ASSET__LPetahXL__"